import { ScanMedia } from "../types/types"
import { genericRequest, scanMediaRoute } from "./service"

export const addScanMedia = async (scanMedia: ScanMedia, sectionScanId: number): Promise<ScanMedia | Error> => {
  const body = JSON.stringify(scanMedia)
  return await genericRequest({ url: `${scanMediaRoute}/${sectionScanId}`, method: "POST", body: body })
}

export const getScanMediaForSection = async (sectionId: number): Promise<ScanMedia[] | Error> => {
  return await genericRequest({ url: `${scanMediaRoute}/scan_media/${sectionId}`, method: "GET" })
}